import { toast } from "react-toastify";
import axiosInstance from "../../../../axios";
// Get Trainer List 
export const getTrainerService = async (payload) => {
  console.log("trainer // payload in gettRainerService : ", payload);
  // Assuming you have a payload object
  if (payload.keyword === undefined) {
    payload.keyword = "";
  }
  if (payload.name === undefined) {
    payload.name = "";
  }

  if (!payload.searchTerm) {
    payload.searchTerm = "";
  }

  if (payload.trainerId === undefined) {
    payload.trainerId = "";
  }

  if (payload.phoneNumber === undefined) {
    payload.phoneNumber = "";
  }
  if (payload.email === undefined) {
    payload.email = "";
  }

  if (payload.phoneNumber === undefined) {
    payload.phoneNumber = "";
  }

  if (payload.batchId === undefined) {
    payload.batchId = "";
  }

  if (payload.skillCategory === undefined) {
    payload.skillCategory = "";
  }

  if (payload.skill === undefined) {
    payload.skill = "";
  }

  try {
    const response = await axiosInstance.get(`/trainer?name=${payload.searchTerm}&trainerId=${payload.trainerId}&email=${payload.email}&phoneNumber=${payload.phoneNumber}&batchId=${payload.batchId}&skillCategory=${payload.skillCategory}&skill=${payload.skill}&pageLength=9999&pageNo=1&keyword=${payload.keyword}`);
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};



// Add Trainer
export const addTrainerService = async (payload) => {
  console.log("trainer // payload in addTrainer : ", payload)
  try {
    const response = await axiosInstance.post(`/trainer`, payload);
    console.log("response in addtrainerservice is : ", response);
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

// Delete Trainer
export const DeleteTrainer = async (payload) => {
  console.log("trainer // payload in DeleteTrainer : ", payload)
  const id = payload.id;
  try {
    const response = await axiosInstance.delete(`/trainer/${id}`);
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

// Get Trainer By Id
export const GetTrainerById = async (payload) => {
  console.log("trainer // payload in Get Trainer bY ID : ", payload, payload?.courseName);
  let courseName = payload?.courseName;
  let skillName = payload?.skillName;
  if (!payload?.courseName) {
    courseName = "";
  }
  if (!payload?.skillName) {
    skillName = "";
  }
  try {
    const response = await axiosInstance.get(`/trainer/${payload.id}?courseName=${courseName}&skillName=${skillName}`);
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};


//Patch Trainer By id 
export const patchTrainerById = async (payload) => {
  console.log("trainer // payload in patch Trainer bY ID : ", payload)
  const id = payload?.TrainerId;
  try {
    const response = await axiosInstance.patch(`/trainer/${id}`, payload?.payLoad);
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};


//Add skill by id 
export const AddTrainerSkill = async (payload) => {
  console.log("trainer // payload in Add Trainer  bY ID : ", payload)
  try {
    const response = await axiosInstance.post(`/trainer/skill/`);
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

//patch skill by id
export const EditTrainerSkill = async (payload) => {
  console.log("trainer // payload in Add Trainer  bY ID : ", payload)
  const id = payload?.id;
  try {
    const response = await axiosInstance.patch(`/trainer/skill/${id}`);
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};









